/** Generate by swagger-axios-codegen */
// @ts-nocheck
 

/** Generate by swagger-axios-codegen */
/* eslint-disable */
// @ts-nocheck
import axiosStatic, { type AxiosInstance, type AxiosRequestConfig } from 'axios';

export interface IRequestOptions extends AxiosRequestConfig {
    /**
     * show loading status
     */
    loading?: boolean;
    /**
     * display error message
     */
    showError?: boolean;
    /**
     * data security, extended fields are encrypted using the specified algorithm
     */
    security?: Record<string, 'md5' | 'sha1' | 'aes' | 'des'>;
    /**
     * indicates whether Authorization credentials are required for the request
     * @default true
     */
    withAuthorization?: boolean;
}

export interface IRequestConfig {
    method?: any;
    headers?: any;
    url?: any;
    data?: any;
    params?: any;
}

// Add options interface
export interface ServiceOptions {
    axios?: AxiosInstance;
    /** only in axios interceptor config*/
    loading: boolean;
    showError: boolean;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
    if (serviceOptions.axios) {
        return serviceOptions.axios
            .request(configs)
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    } else {
        throw new Error('please inject yourself instance like axios  ');
    }
}

export function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
    const configs: IRequestConfig = {
        loading: serviceOptions.loading,
        showError: serviceOptions.showError,
        ...options,
        method,
        url,
    };
    configs.headers = {
        ...options.headers,
        'Content-Type': contentType,
    };
    return configs;
}

export const basePath = '';

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
    [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
    items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
    items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
    totalCount?: number;
    items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
    totalCount?: number;
    items?: T[];
}

// customer definition
// empty

export class ImapClientService {
    /**
     *
     */
    static deleteMessages(
        params: {
            /** requestBody */
            body?: DeleteMessagesDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/imap-client/delete-messages';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static forceUpdate(
        params: {
            /** requestBody */
            body?: ForceUpdateDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/imap-client/force-update';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static folderList(
        params: {
            /** requestBody */
            body?: FolderListDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/imap-client/folder-list';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;

            axios(configs, resolve, reject);
        });
    }
}

export interface DeleteMessagesDto {
    /**  */
    message_ids: string[];

    /**  */
    email_config_id: string;
}

export interface ForceUpdateDto {
    /**  */
    email_config_id: string;
}

export interface EmailConfigEntity {
    /**  */
    active_imap?: boolean;

    /**  */
    active_smtp?: boolean;

    /**  */
    aud_when_sys_user_id?: object;

    /**  */
    auth_smtp?: boolean;

    /**  */
    default_email?: boolean;

    /**  */
    email?: string;

    /**  */
    host_imap?: string;

    /**  */
    host_smtp?: string;

    /**  */
    login?: string;

    /**  */
    name?: string;

    /**  */
    password?: string;

    /**  */
    port_imap?: string;

    /**  */
    port_smtp?: string;

    /**  */
    signature?: string;

    /**  */
    ssl_imap?: boolean;

    /**  */
    ssl_smtp?: boolean;

    /**  */
    tls_imap?: boolean;

    /**  */
    person_id?: string;

    /**  */
    tls_smtp?: boolean;

    /**  */
    sys_user_id?: string;

    /**  */
    mailbox_behaviours?: object;
}

export interface FolderListDto {
    /**  */
    config: EmailConfigEntity;
}
